module.exports = __webpack_public_path__ + "img/wifi-slash.4b9553f6.svg";